import pages from './social-pages.json' with { type: 'json' };

export const socialPages = pages;
export const socialAssetVersion = 'v1';
export const socialAssetRevision = '2';
const origin = 'https://bckt.io';
const sdkPage = pages.find(page => page.path === '/sdks')!;
const sdkGuides = [
  { ...sdkPage, path: '/sdks/python', title: 'Install the Python SDK | BCKT', description: 'Install bckt-sdk with pip, configure your API key and upload your first file. Use the official BCKT Python SDK with sync and async clients.' },
  { ...sdkPage, path: '/sdks/fivem-redm', title: 'Install the FiveM & RedM SDK | BCKT', description: 'Install the BCKT Lua SDK, configure your server API key and connect uploads, screenshots and logs to your FiveM or RedM resources.' },
  { ...sdkPage, path: '/sdks/nodejs', title: 'Install the Node.js SDK | BCKT', description: 'Install @bckt/sdk with npm, configure your API key and upload your first file. Get started with the official BCKT SDK for JavaScript and TypeScript.' },
];

export function pageMetadata(pathname: string) {
  const cleanPath = pathname.split(/[?#]/)[0]?.replace(/\/+$/, '') || '/';
  const page = [...socialPages, ...sdkGuides].find((item) => item.path === cleanPath);
  const selected = page ?? pages[0]!;
  return {
    ...selected,
    title: page ? page.title : cleanPath.startsWith('/dashboard') ? 'Dashboard | BCKT' : 'BCKT',
    canonical: origin + (page ? page.path : cleanPath),
    image: `${origin}/branding/social/bckt-social-${selected.slug}-1200x630-${socialAssetVersion}.png?v=${socialAssetRevision}`,
    robots: page ? 'index, follow, max-image-preview:large' : 'noindex, follow',
  };
}

export function metadataEntries(pathname: string) {
  const page = pageMetadata(pathname);
  return [
    ['name', 'description', page.description],
    ['name', 'robots', page.robots],
    ['property', 'og:type', 'website'],
    ['property', 'og:site_name', 'BCKT'],
    ['property', 'og:locale', 'en_US'],
    ['property', 'og:title', page.title],
    ['property', 'og:description', page.description],
    ['property', 'og:url', page.canonical],
    ['property', 'og:image', page.image],
    ['property', 'og:image:secure_url', page.image],
    ['property', 'og:image:type', 'image/png'],
    ['property', 'og:image:width', '1200'],
    ['property', 'og:image:height', '630'],
    ['property', 'og:image:alt', page.imageAlt],
    ['name', 'twitter:card', 'summary_large_image'],
    ['name', 'twitter:title', page.title],
    ['name', 'twitter:description', page.description],
    ['name', 'twitter:image', page.image],
    ['name', 'twitter:image:alt', page.imageAlt],
  ] as const;
}

function escapeHtml(value: string) {
  return value.replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]!);
}

export function renderSocialMetadata(html: string, pathname: string) {
  const page = pageMetadata(pathname);
  const head = [
    `<title>${escapeHtml(page.title)}</title>`,
    `<link rel="canonical" href="${escapeHtml(page.canonical)}" />`,
    ...metadataEntries(pathname).map(([attribute, key, value]) => `<meta ${attribute}="${key}" content="${escapeHtml(value)}" />`),
  ].join('\n    ');
  return html.replace(/<!-- page-metadata:start -->[\s\S]*?<!-- page-metadata:end -->/, `<!-- page-metadata:start -->\n    ${head}\n    <!-- page-metadata:end -->`);
}
